/* eslint-disable import/no-duplicates */
import React from 'react';
import PropTypes from 'prop-types';
import BarSeries from 'components/bar-series';
import BarStepSeries from 'components/bar-step-series';
import DifferenceBarSeries from 'components/difference-bar-series';
import LinearAxis from 'components/linear-axis';
import {TOP} from 'constants/orient';
import {BAR_STEP_SERIES, DIFFERENCE_BAR_SERIES} from 'constants/series-type';
import {CURRENCY} from 'constants/value-type';
import {NUMERIC} from 'constants/value-type';
import {PERCENTAGE} from 'constants/value-type';
import linearDomain from 'domains/linear-domain';
import numericRange from 'ranges/numeric-range';
import linearScale from 'scales/linear-scale';
import styles from './index.css';

export default class BarGroup extends React.Component {
  static propTypes = {
    activeIndex: PropTypes.number,
    axisHeight: PropTypes.number,
    barHeight: PropTypes.number,
    group: PropTypes.object,
    numTicks: PropTypes.number,
    showAxis: PropTypes.bool,
    tickPadding: PropTypes.number,
    valueType: PropTypes.oneOf([CURRENCY, NUMERIC, PERCENTAGE]),
    verticalSpacing: PropTypes.number,
    width: PropTypes.number,
  };

  static defaultProps = {
    activeIndex: -1,
    axisHeight: 18,
    barHeight: 0,
    group: {},
    numTicks: 5,
    showAxis: true,
    tickPadding: 4,
    valueType: NUMERIC,
    verticalSpacing: 0,
    width: 0,
  };

  getDomain(series, clampToZero) {
    // Bar charts require one extra tiny piece
    // of logic that other chart types do not,
    // so we wrap the LinearDomain and ensure
    // that it starts at 0 if clampToZero is true.
    // LinearDomain itself clamps positive values
    // to zero, but not negative values. For bar
    // charts, negative values must be clamped also.
    const domain = linearDomain(series, clampToZero);
    return [clampToZero ? 0 : domain[0], domain[1]];
  }

  getSeries(type) {
    switch (type) {
      case BAR_STEP_SERIES:
        return BarStepSeries;
      case DIFFERENCE_BAR_SERIES:
        return DifferenceBarSeries;
      default:
        return BarSeries;
    }
  }

  render() {
    const {
      activeIndex,
      axisHeight,
      barHeight,
      group,
      numTicks,
      showAxis,
      tickPadding,
      valueType,
      verticalSpacing,
      width,
    } = this.props;
    const {clampToZero, series = []} = group;

    const domain = this.getDomain(series, clampToZero);
    const range = numericRange(width);
    const scale = linearScale(domain, range);

    return (
      <g className={styles.BarGroup}>
        {showAxis && group.showAxis ? (
          <LinearAxis
            height={axisHeight}
            numTicks={numTicks}
            orient={TOP}
            scale={scale}
            tickPadding={tickPadding}
            valueType={valueType}
            width={width}
          />
        ) : null}

        <g transform={`translate(0 ${axisHeight})`}>
          {series.map((datum, index) => {
            const Series = this.getSeries(datum.type);
            return (
              <Series
                {...datum}
                activeIndex={activeIndex}
                barHeight={barHeight}
                key={`series${index}`}
                numSeries={series.length}
                scale={scale}
                verticalSpacing={verticalSpacing}
                width={width}
              />
            );
          })}
        </g>
      </g>
    );
  }
}
